// Khai báo những component cần nhúng ra ngoài site
import './assets/css/app.scss';
import CartIcon from './components/Cart/CartIcon';
import AddToCartAction from './components/Cart/AddToCartAction';
import CartDetail from './components/Cart/CartDetail';
import PaymentInfo from './components/Cart/PaymentInfo';
import AddToCartButton from './components/Cart/AddToCartButton';
import ContactForm from './components/ContactUs/Form';
import ProductSortSelect from './components/Product/SortSelect';
import ProductPriceSlide from './components/Product/PriceSlide';
import NewsSearchBox from './components/News/SearchBox';
import SearchBox from './components/SearchBox';
import Pagination from './components/Pagination';
